// Third-party
import React, { ReactElement } from 'react';

// Components
import { SearchSelectInput, SelectOption } from '../inputs';
import ActionModal from './ActionModal';
import { ContactPastille } from '../misc';

// Utils
import { formatMessage, FormattedMessage } from '../../../utils/i18n';
import User from '@/types/user';

type Props = {
  show: boolean;
  user: User;
  onConfirm: (id: string) => void;
  onCancel: () => void;
};

type State = {
  selectedAccess?: string;
};

class SwitchAccessModal extends React.Component<Props, State> {
  state: State = {};

  filterAccounts = (option: ReactElement, query: string): boolean => {
    const accesses = this.getAccesses();

    return accesses.some(access => access.user === option.props.value && new RegExp(query, 'gi').test(access.name));
  };

  onSelectDropdown = (selectedAccess: string) => {
    this.setState({ selectedAccess });
  };

  onConfirm = () => {
    if (!this.state.selectedAccess) {
      return;
    }

    this.props.onConfirm(this.state.selectedAccess);
  };

  getAccesses = () => {
    const { user } = this.props;
    let accesses = user.authUser.delegateAccess?.myAccesses || [];

    if (!user.authUser.pureDelegate) {
      accesses = [
        {
          name: `${user.authUser.fname} ${user.authUser.lname}`,
          user: user.authUser.id || '',
        },
      ].concat(accesses);
    }

    return accesses;
  };

  render() {
    const { show, onCancel, user } = this.props;
    const { selectedAccess } = this.state;

    const accesses = this.getAccesses();

    return (
      <ActionModal
        show={show}
        className="switch-access-modal"
        onCancel={onCancel}
        onConfirm={this.onConfirm}
        confirmLabel={formatMessage('Delegates.SwitchAccount')}
        confirmIsDisabled={!selectedAccess || selectedAccess === user.id}
      >
        <h3>
          <FormattedMessage id="Delegates.SwitchAccount" />
        </h3>

        <SearchSelectInput
          onSelect={this.onSelectDropdown}
          data-private
          data-dd-privacy="mask"
          placeholder={formatMessage('Delegates.ChooseAccount')}
          filterOption={this.filterAccounts}
          selectedOptionValue={selectedAccess}
        >
          {accesses.map(access => (
            <SelectOption key={access.user} value={access.user} className="d-flex align-items-center">
              <ContactPastille
                contact={{
                  _id: access.user,
                  fname: access.name.split(' ')[0],
                  lname: access.name.split(' ')[1],
                }}
              />
              <span className="contact-name">{access.name}</span>
            </SelectOption>
          ))}
        </SearchSelectInput>
      </ActionModal>
    );
  }
}

export default SwitchAccessModal;
